module.exports = __webpack_public_path__ + "static/media/main_banner_03.8d077bab.png";